import { render, staticRenderFns } from "./AudienceModal.vue?vue&type=template&id=63ff07f8"
import script from "./AudienceModal.vue?vue&type=script&lang=js"
export * from "./AudienceModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports